import React from 'react'
import { useOutletContext } from 'react-router-dom'
import InvoiceTable from '@components/pages/Billing/Invoice/InvoiceTable.component'
import type { BillingOutletContext } from '@components/pages/Billing/Billing.component'

function BillingInvoicesPage(): React.ReactElement {
  const { hooks } = useOutletContext<BillingOutletContext>()

  return (
    <InvoiceTable
      searchQuery={hooks.searchQuery}
      filters={hooks.filters}
      onAddInvoice={hooks.handleAddFromInvoice}
      onCreateInvoice={hooks.handleCreateInvoice}
      suppressTableLoading={hooks.suppressTableLoading}
    />
  )
}

export default BillingInvoicesPage
